var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Carousel from 'bootstrap/js/dist/carousel';
export class Slider extends Component {
    constructor() {
        super('Slider', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.carousel').each((carousel) => {
                new BS_Carousel(carousel.get(0), {
                    interval: 5000,
                    ride: true,
                    pause: false
                });
                const legend = carousel.find('p');
                carousel.on('slide.bs.carousel', (event) => {
                    legend.addClass('fade');
                    setTimeout(() => {
                        const nextItem = $(event.relatedTarget);
                        legend.removeClass('text-white text-black');
                        legend.addClass(nextItem.data('titleColor'));
                        legend.find('.title').text(nextItem.data('title'));
                        legend.find('.subtitle').text(nextItem.data('subtitle'));
                    }, 400);
                });
                carousel.on('slid.bs.carousel', () => {
                    legend.removeClass('fade');
                });
            });
            this.success();
        });
    }
}
